/** The Action End-Points */
import {
  DEFAULT,
  IO_ADD_INSURANCE_TARGET,
  IO_CHANGE_CONTACTINFO,
  IO_CHANGE_INSURANCE,
  IO_CHANGE_SHOWCONTACTINFO,
  IO_CHANGE_SHOWCQUESTIONS,
  IO_CHANGE_SHOWINSURANCEERRORMESSAGE,
  IO_CHANGE_SHOWEXCEPTIONMESSAGE,
  IO_DELETE_ALL_INSURANCES,
  IO_DELETE_INSURANCE_TARGET,
  IO_UPDATE_SEND_VALUE,
} from '../constants/actionTypes';

/**
 * insuranceSelectionReducer is to update the state container
 * @param {*} state
 * @param {*} action
 * @return {*} newState
 */
const insuranceSelectionReducer = (state, action) =>
  (actions[action.type] || actions[DEFAULT])(state, action);

/**
 * actions is to trigger the selected action type
 */
const actions = {
  [IO_ADD_INSURANCE_TARGET]: (state, action) => addInsurance(state, action),

  [IO_DELETE_INSURANCE_TARGET]: (state, { insuranceId }) =>
    deleteInsurance(state, insuranceId, 'delete'),

  [IO_DELETE_ALL_INSURANCES]: (state, { insuranceId }) =>
    deleteInsurance(state, insuranceId, 'deleteAll'),

  [IO_CHANGE_INSURANCE]: (state, { questions, insurance }) => {
    const { selectedInsurances } = state;
    return {
      ...state,
      selectedInsurances: selectedInsurances.map((record) => ({
        ...record,
        questions: record.id === insurance.id ? questions : record.questions,
      })),
    };
  },

  [IO_CHANGE_CONTACTINFO]: (state, { contactInfo}) => ({
    ...state,
    contactInfo,
  }),

  [IO_CHANGE_SHOWINSURANCEERRORMESSAGE]: (state) => ({
    ...state,
    showInsuranceErrorMessage: true,
  }),

  [IO_UPDATE_SEND_VALUE]: (state, action) => {
    const {id, value} = action
    if (value) {
      return {
        ...state,
        selectedInsurances: state.selectedInsurances.map((item) =>
          item.id === id ? { ...item, sendInsurance: true } : item
        )}
    } else if (!value) {
      return {
        ...state,
        selectedInsurances: state.selectedInsurances.map((item) =>
          item.id === id ? { ...item, sendInsurance: false } : item
        )}
    } else {
      return state
    }
  },

  [IO_CHANGE_SHOWCONTACTINFO]: (state) => ({ ...state, showContactInfo: true }),

  [IO_CHANGE_SHOWCQUESTIONS]: (state) => ({ ...state, showInsurances: true }),

  [IO_CHANGE_SHOWEXCEPTIONMESSAGE]: (state) => ({
    ...state,
    showExceptionMessage: true,
  }),

  [DEFAULT]: (state) => ({ ...state }),
};

/**
 * addInsurance is to create new insurance based on the selected insurance type
 * @param {*} state
 * @param {*} action
 * @return {*} newState
 */
const addInsurance = (state, action) => {
  const {
    icon,
    caption,
    component,
    validator,
    insuranceId,
    defaultCaption,
    questions = {},
    sendInsurance
  } = action;
  const { tiles, selectedInsurances, insuranceSelectionIndex } = state;
  const newSelectedInsurances = [
    ...selectedInsurances,
    {
      icon,
      caption,
      component,
      validator,
      questions,
      defaultCaption,
      type: insuranceId,
      id: insuranceId + (insuranceSelectionIndex + 1),
      sendInsurance
    },
  ];
  const newTiles = tiles.map((record) => ({
    ...record,
    count: record.insuranceId === insuranceId ? record.count + 1 : record.count,
  }));
  return {
    ...state,
    tiles: newTiles,
    showInsuranceErrorMessage: false,
    selectedInsurances: newSelectedInsurances,
    insuranceSelectionIndex: insuranceSelectionIndex + 1,
  };
};

/**
 * makeContactInfo is to prepare contactInfo data for both loggedIn & non-loggedIn user.
 * @param {*} personalData
 */
const makeContactInfo = (personalData) => {
  if (personalData.loggedInUser) {
    const { firstName, lastName, fullName, idNumber, loggedInUser } =
      personalData;

    return {
      firstName,
      lastName,
      fullName,
      idNumber,
      loggedInUser,
    };
  }

  return {};
};

/**
 * deleteInsurance is to delete single or multiple insurance based on the flag value
 * @param {*} state
 * @param {*} insuranceId
 * @param {*} flag
 * @return {*} newState
 */
const deleteInsurance = (state, insuranceId, flag) => {
  const modifier = {
    filterKey: { delete: 'id', deleteAll: 'type' },
    insuranceKey: {
      delete: insuranceId.replace(/[0-9]/g, ''),
      deleteAll: insuranceId,
    },
    countKey: { delete: 1, deleteAll: 0 },
  };
  const {
    tiles,
    contactInfo,
    contactInfoErrors,
    showInsurances,
    showContactInfo,
    selectedInsurances,
    showExceptionMessage,
  } = state;
  const newSelectedInsurances = selectedInsurances
    .filter((item) => item[modifier.filterKey[flag]] !== insuranceId)
    .map((record, index) => ({ ...record, id: `${record.type}${index + 1}` }));

  const insuranceSelectionIndex = newSelectedInsurances.length;
  const newTitles = tiles.map((record) => ({
    ...record,
    count:
      record.insuranceId === modifier.insuranceKey[flag]
        ? modifier.countKey[flag] && record.count - 1
        : record.count,
  }));
  const newState = {
    ...state,
    contactInfo: makeContactInfo(contactInfo),
    contactInfoErrors: {},
    tiles: newTitles,
    showInsurances: false,
    showContactInfo: false,
    insuranceSelectionIndex,
    showInsuranceErrorMessage: false,
    selectedInsurances: newSelectedInsurances,
    showExceptionMessage: false,
  };
  return insuranceSelectionIndex > 0
    ? {
        ...newState,
        showInsurances,
        showContactInfo,
        contactInfo,
        contactInfoErrors,
        showExceptionMessage,
      }
    : newState;
};

export default insuranceSelectionReducer;
